import MeetingRoomIcon from '@material-ui/icons/MeetingRoom';
import DisbursementList from './DisbursementList';
import DisbursementEdit from './DisbursementEdit';

export default {
    list: DisbursementList,
    edit: DisbursementEdit,
    icon: MeetingRoomIcon
};